exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".consultation--base-data a.nav-location{display:flex;align-items:center}.consultation--base-data a.nav-location.disabled{color:#666;pointer-events:none}.consultation--base-data .sticky-footer{position:sticky;bottom:0;background-color:#fff;z-index:9}", ""]);

